(function () {
  if (!document.body.classList.contains('template-index')) return;

  function setHeaderGroupHeight() {
    var announcement = document.getElementById('shopify-section-announcement-bar');
    var header = document.getElementById('shopify-section-header');
    var height = 0;

    if (announcement) height += announcement.offsetHeight;
    if (header) height += header.offsetHeight;

    document.documentElement.style.setProperty('--header-group-height', height + 'px');
  }

  setHeaderGroupHeight();
  window.addEventListener('resize', setHeaderGroupHeight);

  document.querySelectorAll('.footer img').forEach(function (img) {
    img.loading = 'eager';
    if (img.decode) img.decode().catch(function () {});
  });
})();
